"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataReportProvider = void 0;
/** @TranslateToPython */
var DataReportProvider;
(function (DataReportProvider) {
    // Credit report providers
    DataReportProvider["experian"] = "experian";
    DataReportProvider["transUnion"] = "transUnion";
    DataReportProvider["equifax"] = "equifax";
    // Property report providers
    DataReportProvider["houseCanary"] = "houseCanary";
    DataReportProvider["coreLogic"] = "coreLogic";
    DataReportProvider["dataTree"] = "dataTree";
    DataReportProvider["fidelity"] = "fidelity";
    DataReportProvider["clearCapital"] = "clearCapital";
    DataReportProvider["usCensusBureau"] = "usCensusBureau";
    // Income report providers
    DataReportProvider["workNumber"] = "workNumber";
    DataReportProvider["plaid"] = "plaid";
    DataReportProvider["manualIncomeVerification"] = "manualIncomeVerification";
    DataReportProvider["ocrolus"] = "ocrolus";
    DataReportProvider["informedIQ"] = "informedIQ";
    DataReportProvider["irs"] = "irs";
    // MethodFi report provider
    DataReportProvider["methodFi"] = "methodFi";
    // User or Ops attestation of information (e.g. lien attestation, manual lien info, etc.)
    DataReportProvider["attestation"] = "attestation";
    // For DataReportType that are from Aven's internal database and not associated with a specific provider
    // E.g. loanApplicationReport, applicantReport, homeReport, mailReport, manualOfferReport, avenAccountDataReport, etc.
    DataReportProvider["aven"] = "aven";
})(DataReportProvider || (exports.DataReportProvider = DataReportProvider = {}));
